export default __webpack_public_path__ + "static/media/heatmap.d7fb5739.svg";